module.exports = __webpack_public_path__ + "img/scan.aec11e8c.svg";